import { forwardRef, type Ref, type SVGProps } from "react";

function SvgJobWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="176"
      height="120"
      viewBox="0 0 176 120"
      fill="none"
      {...props}
    >
      <path
        d="M70.4659 40.7778H62.4506C55.8106 40.7778 50.4277 46.0757 50.4277 52.6111V84.1667C50.4277 90.702 55.8106 96 62.4506 96H114.55C121.19 96 126.573 90.702 126.573 84.1667V52.6111C126.573 46.0757 121.19 40.7778 114.55 40.7778H106.535M70.4659 40.7778V36.8333C70.4659 30.298 75.8487 25 82.4888 25H94.5116C101.152 25 106.535 30.298 106.535 36.8333V40.7778M70.4659 40.7778H106.535"
        stroke="url(#paint0_linear_99_3975)"
        strokeWidth="10"
      />
      <rect x="107" y="54.5" width="39" height="39" rx="19.5" fill="#BD6801" />
      <rect x="107" y="54.5" width="39" height="39" rx="19.5" stroke="white" />
      <path
        d="M126.5 68V75M126.5 78V79"
        stroke="white"
        strokeWidth="1.51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_99_3975"
          x1="88.5002"
          y1="25"
          x2="88.5002"
          y2="96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#FFE3C3" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgJobWarning);
export default ForwardRef;
